import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromCompanion from './reducers/companion.reducer';
import {EffectsModule} from '@ngrx/effects';
import {CompanionEffects} from './effects/companion.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('companion', fromCompanion.reducer),
    StoreModule.forFeature('companionOverView', fromCompanion.companionOverViewReducer),
    StoreModule.forFeature('companionProtectionProcessDevice', fromCompanion.companionProtectionProcessDeviceReducer),
    StoreModule.forFeature('resendDataOfCompanionProtectionProcess', fromCompanion.resendDataOfCompanionProtectionProcessReducer),

    EffectsModule.forFeature([ CompanionEffects ]),
  ]
})
export class CompanionModule { }
